export default __webpack_public_path__ + "static/lozenge-anatomy-dark-75dab2c2c2b023a1f92921075c0faede.png";